
$('.Header_button_cta_mn').click(function(evt){
  evt.preventDefault();
  $('html, body').animate({
      scrollTop: $(".bf_outer").offset().top-200
  }, 500);
});

$(document).on("click",'.Mobile_nav_trigger',function() {
    // if ($('.Mobile_nav_trigger #check').is(":checked")){
    //     console.log('Checked');
    //     $('.Mobile_header_overlay').toggleClass('active');
    //     $('.Mobile_header_nav_outer').toggleClass('active');
    //     $('body').toggleClass('Overflow_hidden');
    // }
    $('.Mobile_header_overlay').addClass('active');
    $('.Mobile_header_nav_outer').addClass('active');
    $('body').addClass('Overflow_hidden');
}); 

$('.hm_nav_close_btn').click(function(){
    $('.Mobile_header_overlay').removeClass('active');
    $('.Mobile_header_nav_outer').removeClass('active');
    $('body').removeClass('Overflow_hidden');
});

$('.has_child_items_js').mouseover(function(){
    // $('.Header_menu_child_container_outer').slideUp();
    $(this).find('.Header_menu_child_container_outer').slideDown();
    $('.has_child_items_js').not(this).find('.Header_menu_child_container_outer').slideUp();
});

$('.Container_blocks_outer_whole').mouseover(function(){
    $('.Header_menu_child_container_outer').slideUp();
});

$('.page-width').mouseover(function(){
    $('.Header_menu_child_container_outer').slideUp();
});

$('.Page_width').mouseover(function(){
    $('.Header_menu_child_container_outer').slideUp();
});

$('.color-background-1').mouseover(function(){
    $('.Header_menu_child_container_outer').slideUp();
});


$('.not_has_child_items_js').mouseover(function(){
    $('.Header_menu_child_container_outer').slideUp();
});

$('.Header_menu_child_container_outer').mouseleave(function() {
    // $('.Header_menu_child_container_outer').slideUp();
    // Get the ".has_child_items_js" element
    const hasChildItemsElement = $('.has_child_items_js');

    // Check if the mouse is currently over the ".has_child_items_js" element
    if (hasChildItemsElement.is(':hover')) {
        return; // Do nothing if the mouse is over ".has_child_items_js"
    }

    // If the mouse is not over ".has_child_items_js", slide up the ".Header_menu_child_container_outer" element
    $('.Header_menu_child_container_outer').slideUp();
});

$('.mobile_has_child_items').click(function(){
    $('.Mobile_main_item').removeClass('active');
    $(this).toggleClass('active');
    $(this).parent('div').parent('div').find('.Mobile_inner_child_nav').slideToggle();
});

// $('.pf_atc_button_slidecart').click(function(){
//   alert();
// });

  $('.header_menu_item_to_scroll__pdp').click(function(evt){
    evt.preventDefault();
    $('.hm_nav_close_btn').trigger('click');
    $('html, body').animate({
        scrollTop: $(".bs_outer").offset().top-200
    }, 500);
  });
